import React from 'react';
import {Helmet} from 'react-helmet';
import ContentWrapper from '../styles/ContentWrapper';

var Tos = function () {
  return (
    <React.Fragment>
      <Helmet>
        <meta name="robots" content="noindex, nofollow"/>
      </Helmet>
      <article role="article" about="/legal/agb" typeof="schema:WebPage">
        <ContentWrapper>
                    <span
                      property="schema:name"
                      content="Allgemeine Geschäftsbedingungen"
                      className="stolo-hidden"
                    />
          <div>
            <h1>Allgemeine Gesch&auml;ftsbedingungen mit Kundeninformationen</h1>
            <h2>Inhaltsverzeichnis</h2>
            <ol>
              <li>Geltungsbereich</li>
              <li>Vertragsschluss</li>
              <li>Widerrufsrecht</li>
              <li>Preise und Zahlungsbedingungen</li>
              <li>Liefer- und Versandbedingungen</li>
              <li>Einr&auml;umung von Nutzungsrechten f&uuml;r digitale Inhalte</li>
              <li>Eigentumsvorbehalt</li>
              <li>M&auml;ngelhaftung (Gew&auml;hrleistung)</li>
              <li>Haftung</li>
              <li>Besondere Bedingungen f&uuml;r die Verarbeitung von Waren nach
                bestimmten Vorgaben des Kunden
              </li>
              <li>Einl&ouml;sung von Aktionsgutscheinen</li>
              <li>Einl&ouml;sung von Geschenkgutscheinen</li>
              <li>Anwendbares Recht</li>
              <li>Gerichtsstand</li>
              <li>Alternative Streitbeilegung</li>
            </ol>
            <h2>1) Geltungsbereich</h2>
            <p><b>1.1</b>&nbsp;Diese Allgemeinen Gesch&auml;ftsbedingungen
              (nachfolgend &quot;AGB&quot;) der Becker &amp; Karsten UG
              (haftungsbeschr&auml;nkt) (nachfolgend &quot;wir/uns&quot;), gelten f&uuml;r
              alle Vertr&auml;ge zur Lieferung von Waren, die du als Verbraucher oder
              Unternehmer (nachfolgend &bdquo;du/dich&#8220;) mit uns hinsichtlich der von
              uns in unserem Online-Shop dargestellten Waren abschlie&szlig;t. Hiermit
              widersprechen wir der Einbeziehung deiner eigenen Bedingungen, es sei denn,
              wir haben etwas anderes mit dir vereinbart.</p>
            <p><b>1.2</b>&nbsp;F&uuml;r Vertr&auml;ge zur Lieferung von Gutscheinen gelten
              diese AGB entsprechend, sofern insoweit nicht etwas Abweichendes geregelt
              ist.</p>
            <p><b>1.3</b>&nbsp;F&uuml;r Vertr&auml;ge zur Bereitstellung von digitalen
              Inhalten gelten diese AGB entsprechend, sofern insoweit nicht etwas
              Abweichendes geregelt ist. Digitale Inhalte im Sinne dieser AGB sind Daten,
              die in digitaler Form erstellt und bereitgestellt werden.</p>
            <p><b>1.4</b>&nbsp;Verbraucher im Sinne dieser AGB bist du, wenn du ein
              Rechtsgesch&auml;ft zu Zwecken abschlie&szlig;t, die &uuml;berwiegend weder
              deiner gewerblichen noch deiner selbst&auml;ndigen beruflichen
              T&auml;tigkeit zugerechnet werden k&ouml;nnen.</p>
            <p><b>1.5</b>&nbsp;Unternehmer im Sinne dieser AGB bist du als nat&uuml;rliche
              oder juristische Person oder als rechtsf&auml;hige Personengesellschaft, die
              bei Abschluss eines Rechtsgesch&auml;fts in Aus&uuml;bung deiner
              gewerblichen oder selbst&auml;ndigen beruflichen T&auml;tigkeit handelt.</p>
            <h2>2) Vertragsschluss</h2>
            <p><b>2.1</b>&nbsp;Die in unserem Online-Shop enthaltenen
              Produktbeschreibungen stellen keine verbindlichen Angebote unsererseits dar,
              sondern dienen zur Abgabe eines verbindlichen Angebots durch dich.</p>
            <p><b>2.2</b>&nbsp;Du kannst das Angebot &uuml;ber das in unseren Online-Shop
              integrierte Online-Bestellformular abgeben. Dabei gibst du, nachdem du die
              ausgew&auml;hlten Waren in den virtuellen Warenkorb gelegt und den
              elektronischen Bestellprozess durchlaufen hast, durch Klicken des den
              Bestellvorgang abschlie&szlig;enden Buttons ein rechtlich verbindliches
              Vertragsangebot in Bezug auf die im Warenkorb enthaltenen Waren ab.</p>
            <p><b>2.3</b>&nbsp;Wir k&ouml;nnen dein Angebot innerhalb von f&uuml;nf Tagen
              annehmen,</p>
            <ul>
              <li>indem wir dir eine schriftliche Auftragsbest&auml;tigung oder eine
                Auftragsbest&auml;tigung in Textform (Fax oder E-Mail) &uuml;bermitteln,
                wobei insoweit der Zugang der Auftragsbest&auml;tigung bei dir
                ma&szlig;geblich ist, oder
              </li>
              <li>indem wir dir die bestellte Ware liefern, wobei insoweit der Zugang der
                Ware bei dir ma&szlig;geblich ist, oder
              </li>
              <li>indem wir dich nach Abgabe deiner Bestellung zur Zahlung auffordern.
              </li>
            </ul>
            <p>Liegen mehrere der vorgenannten Alternativen vor, kommt der Vertrag in dem
              Zeitpunkt zustande, in dem eine der vorgenannten Alternativen zuerst
              eintritt. Die Frist zur Annahme deines Angebots beginnt am Tag nach der
              Absendung deines Angebots und endet mit dem Ablauf des f&uuml;nften Tages,
              welcher auf die Absendung des Angebots folgt. Nehmen wir dein Angebot
              innerhalb vorgenannter Frist nicht an, so gilt dies als Ablehnung des
              Angebots mit der Folge, dass du nicht mehr an deine Willenserkl&auml;rung
              gebunden bist.</p>
            <p><b>2.4</b>&nbsp;Bei Auswahl einer von PayPal angebotenen Zahlungsart
              erfolgt die Zahlungsabwicklung &uuml;ber den Zahlungsdienstleister PayPal
              (Europe) S.&agrave; r.l. et Cie, S.C.A., 22-24 Boulevard Royal, L-2449
              Luxemburg (im Folgenden: &bdquo;PayPal&#8220;), unter Geltung der
              PayPal-Nutzungsbedingungen, einsehbar unter <a
                href="https://www.paypal.com/de/legalhub/paypal/useragreement-full"
                target="_blank">https://www.paypal.com/de/legalhub/paypal/useragreement-full
              </a> oder &ndash; falls du nicht &uuml;ber ein PayPal-Konto
              verf&uuml;gst &ndash; unter Geltung der Bedingungen f&uuml;r Zahlungen ohne
              PayPal-Konto, einsehbar unter <a
                href="https://www.paypal.com/de/legalhub/paypal/privacywax-full"
                target="_blank">https://www.paypal.com/de/legalhub/paypal/privacywax-full</a>.
              Zahlst du mittels einer im Online-Bestellvorgang ausw&auml;hlbaren von
              PayPal angebotenen Zahlungsart, erkl&auml;ren wir schon jetzt die Annahme
              deines Angebots in dem Zeitpunkt, in dem du den Button anklickst, welcher
              den Bestellvorgang abschlie&szlig;t.
            </p>
            <p><b>2.5</b>&nbsp;Bei der Bestellung &uuml;ber unser Online-Bestellformular
              speichern wir den Vertragstext nach dem Vertragsschluss und &uuml;bermitteln
              ihn dir nach Absendung deiner Bestellung in Textform (z. B. E-Mail, Fax oder
              Brief). Eine dar&uuml;ber hinausgehende Zug&auml;nglichmachung des
              Vertragstextes erfolgt nicht durch uns. Sofern du vor Absendung deiner
              Bestellung ein Nutzerkonto in unserem Online-Shop eingerichtet hast, werden
              deine Bestelldaten auf unserer Website archiviert und k&ouml;nnen von
              dir &uuml;ber dein passwortgesch&uuml;tztes Nutzerkonto unter Angabe der
              entsprechenden Login-Daten kostenlos abgerufen werden.</p>
            <p><b>2.6</b>&nbsp;Vor verbindlicher Abgabe der Bestellung &uuml;ber unser
              Online-Bestellformular kannst du m&ouml;gliche Eingabefehler durch
              aufmerksames Lesen der auf dem Bildschirm dargestellten Informationen
              erkennen. Ein wirksames technisches Mittel zur besseren Erkennung von
              Eingabefehlern kann dabei die Vergr&ouml;&szlig;erungsfunktion deines
              Browsers sein, mit deren Hilfe die Darstellung auf dem Bildschirm
              vergr&ouml;&szlig;ert wird. Deine Eingaben kannst du im Rahmen des
              elektronischen Bestellprozesses so lange &uuml;ber die &uuml;blichen
              Tastatur- und Mausfunktionen korrigieren, bis du den Button anklickst,
              welcher den Bestellvorgang abschlie&szlig;t.</p>
            <p><b>2.7</b>&nbsp;F&uuml;r den Vertragsschluss stehen dir unterschiedliche
              Sprachen zur Verf&uuml;gung. Die konkrete Sprachauswahl wird im Online-Shop
              angezeigt.</p>
            <p><b>2.8</b>&nbsp;Die Bestellabwicklung und Kontaktaufnahme finden in der
              Regel per E-Mail und automatisierter Bestellabwicklung statt. Du hast
              sicherzustellen, dass die von dir zur Bestellabwicklung angegebene
              E-Mail-Adresse zutreffend ist, so dass unter dieser Adresse die von uns
              versandten E-Mails empfangen werden k&ouml;nnen. Insbesondere hast du bei
              dem Einsatz von SPAM-Filtern sicherzustellen, dass alle von uns oder von uns
              mit der Bestellabwicklung beauftragten Dritten versandten E-Mails zugestellt
              werden k&ouml;nnen.</p>
            <h2>3) Widerrufsrecht</h2>
            <p><b>3.1</b>&nbsp;Verbrauchern steht grunds&auml;tzlich ein Widerrufsrecht
              zu.</p>
            <p><b>3.2</b>&nbsp;N&auml;here Informationen zum Widerrufsrecht ergeben sich
              aus unserer Widerrufsbelehrung.</p>
            <p><b>3.3</b>&nbsp;Das Widerrufsrecht gilt nicht f&uuml;r Verbraucher, die zum
              Zeitpunkt des Vertragsschlusses keinem Mitgliedstaat der Europ&auml;ischen
              Union angeh&ouml;ren und deren alleiniger Wohnsitz und Lieferadresse zum
              Zeitpunkt des Vertragsschlusses au&szlig;erhalb der Europ&auml;ischen Union
              liegen.</p>
            <h2>4) Preise und Zahlungsbedingungen</h2>
            <p><b>4.1</b>&nbsp;Sofern sich aus unserer Produktbeschreibung nichts anderes
              ergibt, handelt es sich bei den angegebenen Preisen um Gesamtpreise, die die
              gesetzliche Umsatzsteuer enthalten. Gegebenenfalls zus&auml;tzlich
              anfallende Liefer- und Versandkosten werden in der jeweiligen
              Produktbeschreibung gesondert angegeben.</p>
            <p><b>4.2</b>&nbsp;Bei Lieferungen in L&auml;nder au&szlig;erhalb der
              Europ&auml;ischen Union k&ouml;nnen im Einzelfall weitere Kosten anfallen,
              die wir nicht zu vertreten haben und die von dir zu tragen sind. Hierzu
              z&auml;hlen beispielsweise Kosten f&uuml;r die Geld&uuml;bermittlung durch
              Kreditinstitute (z.B. &Uuml;berweisungsgeb&uuml;hren,
              Wechselkursgeb&uuml;hren) oder einfuhrrechtliche Abgaben bzw. Steuern (z.B.
              Z&ouml;lle). Solche Kosten k&ouml;nnen in Bezug auf die
              Geld&uuml;bermittlung auch dann anfallen, wenn die Lieferung nicht in ein
              Land au&szlig;erhalb der Europ&auml;ischen Union erfolgt, du die Zahlung
              aber von einem Land au&szlig;erhalb der Europ&auml;ischen Union aus
              vornimmst.</p>
            <p><b>4.3</b>&nbsp;Die Zahlungsm&ouml;glichkeit/en wird/werden dir in unserem
              Online-Shop mitgeteilt.</p>
            <p><b>4.4</b>&nbsp;Ist Vorauskasse per Bank&uuml;berweisung vereinbart, ist
              die Zahlung sofort nach Vertragsabschluss f&auml;llig, sofern wir mit dir
              keinen sp&auml;teren F&auml;lligkeitstermin vereinbart haben.</p>
            <p><b>4.5</b>&nbsp;Bei Auswahl einer &uuml;ber den
              Zahlungsdienst &quot;Shopify Payments&quot; angebotenen Zahlungsart erfolgt
              die Zahlungsabwicklung durch den Zahlungsdienstleister Stripe Payments
              Europe Ltd., 1 Grand Canal Street Lower, Grand Canal Dock, Dublin, Irland
              (nachfolgend &quot;Stripe&quot;). Die einzelnen &uuml;ber Shopify Payments
              angebotenen Zahlungsarten werden dir in unserem Online-Shop mitgeteilt. Zur
              Abwicklung von Zahlungen kann sich Stripe weiterer Zahlungsdienste bedienen,
              f&uuml;r die ggf. besondere Zahlungsbedingungen gelten, auf die du ggf.
              gesondert hingewiesen wirst. Weitere Informationen zu &quot;Shopify
              Payments&quot; sind im Internet unter <a
                href="https://www.shopify.com/legal/terms-payments-de"
                target="_blank">https://www.shopify.com/legal/terms-payments-de</a> abrufbar.
            </p>
            <p><b>4.6</b>&nbsp;Bei Auswahl einer &uuml;ber den
              Zahlungsdienst &bdquo;Stripe&#8220; angebotenen Zahlungsart erfolgt die
              Zahlungsabwicklung &uuml;ber den Zahlungsdienstleister Stripe Payments
              Europe Ltd., 1 Grand Canal Street Lower, Grand Canal Dock, Dublin, Irland
              (nachfolgend &quot;Stripe&quot;). Die einzelnen &uuml;ber Stripe angebotenen
              Zahlungsarten werden dir in unserem Online-Shop mitgeteilt. Zur Abwicklung
              von Zahlungen kann sich Stripe weiterer Zahlungsdienste bedienen, f&uuml;r
              die ggf. besondere Zahlungsbedingungen gelten, auf die du ggf. gesondert
              hingewiesen wirst. Weitere Informationen zu Stripe sind im Internet unter <a
                href="https://stripe.com/de"
                target="_blank">https://stripe.com/de</a> abrufbar.
            </p>
            <h2>5) Liefer- und Versandbedingungen</h2>
            <p><b>5.1</b>&nbsp;Bieten wir den Versand der Ware an, so erfolgt die
              Lieferung innerhalb des von uns angegebenen Liefergebietes an die von dir
              angegebene Lieferanschrift, sofern nichts anderes vereinbart ist. Bei der
              Abwicklung der Transaktion ist die in unserer Bestellabwicklung angegebene
              Lieferanschrift ma&szlig;geblich.</p>
            <p><b>5.2</b>&nbsp;Scheitert die Zustellung der Ware aus Gr&uuml;nden, die du
              zu vertreten hast, tr&auml;gst du die uns hierdurch entstehenden
              angemessenen Kosten. Dies gilt im Hinblick auf die Kosten f&uuml;r die
              Hinsendung nicht, wenn du dein Widerrufsrecht wirksam aus&uuml;bst. F&uuml;r
              die R&uuml;cksendekosten gilt bei wirksamer Aus&uuml;bung des
              Widerrufsrechts durch dich die in unserer Widerrufsbelehrung hierzu
              getroffene Regelung.</p>
            <p><b>5.3</b>&nbsp;Handelst du als Unternehmer, geht die Gefahr des
              zuf&auml;lligen Untergangs und der zuf&auml;lligen Verschlechterung der
              verkauften Ware auf dich &uuml;ber, sobald wir die Sache dem Spediteur, dem
              Frachtf&uuml;hrer oder der sonst zur Ausf&uuml;hrung der Versendung
              bestimmten Person oder Anstalt ausgeliefert haben. Handelst du als
              Verbraucher, geht die Gefahr des zuf&auml;lligen Untergangs und der
              zuf&auml;lligen Verschlechterung der verkauften Ware grunds&auml;tzlich erst
              mit &Uuml;bergabe der Ware an dich oder eine empfangsberechtigte
              Person &uuml;ber. Abweichend hiervon geht die Gefahr des zuf&auml;lligen
              Untergangs und der zuf&auml;lligen Verschlechterung der verkauften Ware auch
              wenn du als Verbraucher handelst bereits auf dich &uuml;ber, sobald wir die
              Sache dem Spediteur, dem Frachtf&uuml;hrer oder der sonst zur
              Ausf&uuml;hrung der Versendung bestimmten Person oder Anstalt ausgeliefert
              haben, wenn du den Spediteur, den Frachtf&uuml;hrer oder die sonst zur
              Ausf&uuml;hrung der Versendung bestimmte Person oder Anstalt mit der
              Ausf&uuml;hrung beauftragt hast und wir dir diese Person oder Anstalt zuvor
              nicht benannt haben.</p>
            <p><b>5.4</b>&nbsp;Wir behalten uns das Recht vor, im Falle nicht richtiger
              oder nicht ordnungsgem&auml;&szlig;er Selbstbelieferung vom Vertrag
              zur&uuml;ckzutreten. Dies gilt nur f&uuml;r den Fall, dass die
              Nichtlieferung nicht von uns zu vertreten ist und wir mit der gebotenen
              Sorgfalt ein konkretes Deckungsgesch&auml;ft mit dem Zulieferer
              abgeschlossen haben. Wir werden alle zumutbaren Anstrengungen unternehmen,
              um die Ware zu beschaffen. Im Falle der Nichtverf&uuml;gbarkeit oder der nur
              teilweisen Verf&uuml;gbarkeit der Ware wirst du unverz&uuml;glich informiert
              und die Gegenleistung wird dir unverz&uuml;glich erstattet.</p>
            <p><b>5.5</b>&nbsp;Selbstabholung ist aus logistischen Gr&uuml;nden nicht
              m&ouml;glich.</p>
            <p><b>5.6</b>&nbsp;Gutscheine werden dir wie folgt bereitgestellt:</p>
            <ul>
              <li>per E-Mail</li>
              <li>postalisch</li>
            </ul>
            <p><b>5.7</b>&nbsp;Digitale Inhalte werden dir wie folgt bereitgestellt:</p>
            <p>- per Download</p>
            <h2>6) Einr&auml;umung von Nutzungsrechten f&uuml;r digitale Inhalte</h2>
            <p><b>6.1</b>&nbsp;Sofern sich aus der Inhaltsbeschreibung in unserem
              Online-Shop nichts anderes ergibt, r&auml;umen wir dir an den
              bereitgestellten Inhalten das nicht ausschlie&szlig;liche, &ouml;rtlich und
              zeitlich unbeschr&auml;nkte Recht ein, die Inhalte zu privaten sowie zu
              kommerziellen Zwecken zu nutzen.</p>
            <p><b>6.2</b>&nbsp;Eine Weitergabe der Inhalte an Dritte oder die Erstellung
              von Kopien f&uuml;r Dritte au&szlig;erhalb des Rahmens dieser AGB ist nicht
              gestattet, soweit wir nicht einer &Uuml;bertragung der
              vertragsgegenst&auml;ndlichen Lizenz an den Dritten zugestimmt haben.</p>
            <p><b>6.3</b>&nbsp;Soweit sich der Vertrag auf die einmalige Bereitstellung
              eines digitalen Inhalts bezieht, wird die Rechtseinr&auml;umung erst
              wirksam, wenn du die vertraglich geschuldete Verg&uuml;tung vollst&auml;ndig
              geleistet hast. Wir k&ouml;nnen eine Benutzung der
              vertragsgegenst&auml;ndlichen Inhalte auch schon vor diesem Zeitpunkt
              vorl&auml;ufig erlauben. Ein &Uuml;bergang der Rechte findet durch eine
              solche vorl&auml;ufige Erlaubnis nicht statt.</p>
            <h2>7) Eigentumsvorbehalt</h2>
            <p>Treten wir in Vorleistung, behalten wir uns bis zur vollst&auml;ndigen
              Bezahlung des geschuldeten Kaufpreises das Eigentum an der gelieferten Ware
              vor.</p>
            <h2>8) M&auml;ngelhaftung (Gew&auml;hrleistung)</h2>
            <p>Soweit sich aus den nachfolgenden Regelungen nichts anderes ergibt, gelten
              die Vorschriften der gesetzlichen M&auml;ngelhaftung. Hiervon abweichend
              gilt bei Vertr&auml;gen zur Lieferung von Waren:</p>
            <p><b>8.1</b>&nbsp;Handelst Du als Unternehmer,</p>
            <ul>
              <li>haben wir die Wahl der Art der Nacherf&uuml;llung;</li>
              <li>betr&auml;gt bei neuen Waren die Verj&auml;hrungsfrist f&uuml;r
                M&auml;ngelrechte ein Jahr ab Ablieferung der Ware;
              </li>
              <li>sind bei gebrauchten Waren die M&auml;ngelrechte ausgeschlossen;</li>
              <li>beginnt die Verj&auml;hrung nicht erneut, wenn im Rahmen der
                M&auml;ngelhaftung eine Ersatzlieferung erfolgt.
              </li>
            </ul>
            <p><b>8.2</b>&nbsp;Die vorstehend geregelten Haftungsbeschr&auml;nkungen und
              Fristverk&uuml;rzungen gelten nicht</p>
            <ul>
              <li>f&uuml;r Deine Schadensersatz- und Aufwendungsersatzanspr&uuml;che,</li>
              <li>f&uuml;r den Fall, dass wir den Mangel arglistig verschwiegen haben,
              </li>
              <li>f&uuml;r Waren, die entsprechend ihrer &uuml;blichen Verwendungsweise
                f&uuml;r ein Bauwerk verwendet worden sind und dessen Mangelhaftigkeit
                verursacht haben,
              </li>
              <li>f&uuml;r eine ggf. bestehende Verpflichtung von uns zur Bereitstellung
                von Aktualisierungen f&uuml;r digitale Produkte, bei Vertr&auml;gen zur
                Lieferung von Waren mit digitalen Elementen.
              </li>
            </ul>
            <p><b>8.3</b>&nbsp;Dar&uuml;ber hinaus gilt f&uuml;r Unternehmer, dass die
              gesetzlichen Verj&auml;hrungsfristen f&uuml;r einen ggf. bestehenden
              gesetzlichen R&uuml;ckgriffsanspruch unber&uuml;hrt bleiben.</p>
            <p><b>8.4</b>&nbsp;Handelst du als Kaufmann i.S.d. &sect; 1 HGB, trifft dich
              die kaufm&auml;nnische Untersuchungs- und R&uuml;gepflicht
              gem&auml;&szlig; &sect; 377 HGB. Unterl&auml;sst du die dort geregelten
              Anzeigepflichten, gilt die Ware als genehmigt.</p>
            <p><b>8.5</b>&nbsp;Handelt du als Verbraucher, so wirst du gebeten,
              angelieferte Waren mit offensichtlichen Transportsch&auml;den bei dem
              Zusteller zu reklamieren und uns hiervon in Kenntnis zu setzen. Kommst du
              dem nicht nach, hat dies keinerlei Auswirkungen auf deine gesetzlichen oder
              vertraglichen M&auml;ngelanspr&uuml;che.</p>
            <h2>9) Haftung</h2>
            <p>Der Verk&auml;ufer haftet dir aus allen vertraglichen,
              vertrags&auml;hnlichen und gesetzlichen, auch deliktischen Anspr&uuml;chen
              auf Schadens- und Aufwendungsersatz wie folgt:</p>
            <p><b>9.1</b>&nbsp;Wir haften aus jedem Rechtsgrund uneingeschr&auml;nkt</p>
            <ul>
              <li>bei Vorsatz oder grober Fahrl&auml;ssigkeit,</li>
              <li>bei vors&auml;tzlicher oder fahrl&auml;ssiger Verletzung des Lebens, des
                K&ouml;rpers oder der Gesundheit,
              </li>
              <li>aufgrund eines Garantieversprechens, soweit diesbez&uuml;glich nichts
                anderes geregelt ist,
              </li>
              <li>aufgrund zwingender Haftung wie etwa nach dem Produkthaftungsgesetz.
              </li>
            </ul>
            <p><b>9.2</b>&nbsp;Wenn wir fahrl&auml;ssig eine wesentliche Vertragspflicht
              verletzen, ist die Haftung auf den vertragstypischen, vorhersehbaren Schaden
              begrenzt, sofern wir nicht gem&auml;&szlig; vorstehender Ziffer
              unbeschr&auml;nkt haften. Wesentliche Vertragspflichten sind Pflichten, die
              der Vertrag uns nach seinem Inhalt zur Erreichung des Vertragszwecks
              auferlegt, deren Erf&uuml;llung die ordnungsgem&auml;&szlig;e
              Durchf&uuml;hrung des Vertrags &uuml;berhaupt erst erm&ouml;glicht und auf
              deren Einhaltung du regelm&auml;&szlig;ig vertrauen darfst.</p>
            <p><b>9.3</b>&nbsp;Im &Uuml;brigen ist eine Haftung von uns ausgeschlossen.
            </p>
            <p><b>9.4</b>&nbsp;Vorstehende Haftungsregelungen gelten auch im Hinblick auf
              unsere Haftung f&uuml;r unsere Erf&uuml;llungsgehilfen und gesetzlichen
              Vertreter.</p>
            <h2>10) Besondere Bedingungen f&uuml;r die Verarbeitung von Waren nach
              bestimmten Vorgaben des Kunden</h2>
            <p><b>10.1</b>&nbsp;Schulden wir nach dem Inhalt des Vertrages neben der
              Warenlieferung auch die Verarbeitung der Ware nach bestimmten Vorgaben von
              dir, hast du uns alle f&uuml;r die Verarbeitung erforderlichen Inhalte wie
              Texte, Bilder oder Grafiken in den von uns vorgegebenen Dateiformaten,
              Formatierungen, Bild- und Dateigr&ouml;&szlig;en zur Verf&uuml;gung zu
              stellen und uns die hierf&uuml;r erforderlichen Nutzungsrechte
              einzur&auml;umen. F&uuml;r die Beschaffung und den Rechteerwerb an diesen
              Inhalten bist allein du verantwortlich. Du erkl&auml;rst und &uuml;bernimmst
              die Verantwortung daf&uuml;r, dass du das Recht besitzt, die
              uns &uuml;berlassenen Inhalte zu nutzen. Du tr&auml;gst insbesondere
              daf&uuml;r Sorge, dass hierdurch keine Rechte Dritter verletzt werden,
              insbesondere Urheber-, Marken- und Pers&ouml;nlichkeitsrechte.</p>
            <p><b>10.2</b>&nbsp;Du stellst uns von Anspr&uuml;chen Dritter frei, die diese
              im Zusammenhang mit einer Verletzung ihrer Rechte durch die
              vertragsgem&auml;&szlig;e Nutzung der uns von dir zur Verf&uuml;gung
              gestellten Inhalte durch uns geltend machen k&ouml;nnen. Du &uuml;bernimmst
              hierbei auch die notwendigen Kosten der Rechtsverteidigung
              einschlie&szlig;lich aller Gerichts- und Anwaltskosten in gesetzlicher
              H&ouml;he. Dies gilt nicht, wenn die Rechtsverletzung von dir nicht zu
              vertreten ist. Du bist verpflichtet, uns im Falle einer Inanspruchnahme
              durch Dritte unverz&uuml;glich, wahrheitsgem&auml;&szlig; und
              vollst&auml;ndig alle Informationen zur Verf&uuml;gung zu stellen, die
              f&uuml;r die Pr&uuml;fung der Anspr&uuml;che und eine Verteidigung
              erforderlich sind.</p>
            <p><b>10.3</b>&nbsp;Wir behalten uns vor, Verarbeitungsauftr&auml;ge
              abzulehnen, wenn die von dir hierf&uuml;r &uuml;berlassenen Inhalte gegen
              gesetzliche oder beh&ouml;rdliche Verbote oder gegen die guten Sitten
              versto&szlig;en. Dies gilt insbesondere bei &Uuml;berlassung
              verfassungsfeindlicher, rassistischer, fremdenfeindlicher,
              diskriminierender, beleidigender, jugendgef&auml;hrdender und/oder
              gewaltverherrlichender Inhalte.</p>
            <h2>11) Einl&ouml;sung von Aktionsgutscheinen</h2>
            <p><b>11.1</b>&nbsp;Gutscheine, die wir im Rahmen von Werbeaktionen mit einer
              bestimmten G&uuml;ltigkeitsdauer unentgeltlich ausgeben und die du nicht
              k&auml;uflich erwerben kannst (nachfolgend &quot;Aktionsgutscheine&quot;),
              k&ouml;nnen nur in unserem Online-Shop und nur im angegebenen Zeitraum
              eingel&ouml;st werden.</p>
            <p><b>11.2</b>&nbsp;Einzelne Produkte k&ouml;nnen von der Gutscheinaktion
              ausgeschlossen sein, sofern sich eine entsprechende Einschr&auml;nkung aus
              dem Inhalt deines Aktionsgutscheins ergibt.</p>
            <p><b>11.3</b>&nbsp;Aktionsgutscheine k&ouml;nnen nur vor Abschluss des
              Bestellvorgangs eingel&ouml;st werden. Eine nachtr&auml;gliche Verrechnung
              ist nicht m&ouml;glich.</p>
            <p><b>11.4</b>&nbsp;Pro Bestellung kann immer nur ein Aktionsgutschein von dir
              eingel&ouml;st werden.</p>
            <p><b>11.5</b>&nbsp;Sofern sich unser Aktionsgutschein auf einen konkreten
              Wert und nicht auf einen prozentualen Preisnachlass bezieht, muss dein
              Warenwert mindestens dem Betrag des Aktionsgutscheins entsprechen. Etwaiges
              Restguthaben wird von uns nicht erstattet.</p>
            <p><b>11.6</b>&nbsp;Reicht der Wert des Aktionsgutscheins zur Deckung deiner
              Bestellung nicht aus, kannst du zur Begleichung des Differenzbetrages eine
              der &uuml;brigen von uns angebotenen Zahlungsarten w&auml;hlen.</p>
            <p><b>11.7</b>&nbsp;Das Guthaben eines Aktionsgutscheins wird weder in Bargeld
              ausgezahlt noch verzinst.</p>
            <p><b>11.8</b>&nbsp;Der Aktionsgutschein wird nicht erstattet, wenn du die mit
              dem Aktionsgutschein ganz oder teilweise bezahlte Ware im Rahmen deines
              gesetzlichen Widerrufsrechts zur&uuml;ckgibst.</p>
            <p><b>11.9</b>&nbsp;Der Aktionsgutschein ist &uuml;bertragbar. Wir k&ouml;nnen
              mit befreiender Wirkung an den jeweiligen Inhaber, der den Aktionsgutschein
              in unserem Online-Shop einl&ouml;st, leisten. Dies gilt nicht, wenn wir
              Kenntnis oder grob fahrl&auml;ssige Unkenntnis von der Nichtberechtigung,
              der Gesch&auml;ftsunf&auml;higkeit oder der fehlenden
              Vertretungsberechtigung des jeweiligen Inhabers haben.</p>
            <h2>12) Einl&ouml;sung von Geschenkgutscheinen</h2>
            <p><b>12.1</b>&nbsp;Gutscheine, die &uuml;ber unseren Online-Shop
              k&auml;uflich erworben werden k&ouml;nnen
              (nachfolgend &quot;Geschenkgutscheine&quot;), k&ouml;nnen nur in unserem
              Online-Shop eingel&ouml;st werden, sofern sich aus dem Gutschein nichts
              anderes ergibt.</p>
            <p><b>12.2</b>&nbsp;Geschenkgutscheine und Restguthaben von
              Geschenkgutscheinen sind bis zum Ende des dritten Jahres nach dem Jahr des
              Gutscheinkaufs einl&ouml;sbar. Restguthaben werden dir bis zum Ablaufdatum
              gutgeschrieben.</p>
            <p><b>12.3</b>&nbsp;Geschenkgutscheine k&ouml;nnen nur vor Abschluss des
              Bestellvorgangs eingel&ouml;st werden. Eine nachtr&auml;gliche Verrechnung
              ist nicht m&ouml;glich.</p>
            <p><b>12.4</b>&nbsp;Geschenkgutscheine k&ouml;nnen nur f&uuml;r den Kauf von
              Waren und nicht f&uuml;r den Kauf von weiteren Geschenkgutscheinen verwendet
              werden.</p>
            <p><b>12.5</b>&nbsp;Reicht der Wert des Geschenkgutscheins zur Deckung der
              Bestellung nicht aus, kann zur Begleichung des Differenzbetrages eine
              der &uuml;brigen von uns angebotenen Zahlungsarten gew&auml;hlt werden.</p>
            <p><b>12.6</b>&nbsp;Das Guthaben eines Geschenkgutscheins wird weder in
              Bargeld ausgezahlt noch verzinst.</p>
            <p><b>12.7</b>&nbsp;Der Geschenkgutschein ist &uuml;bertragbar. Der
              Verk&auml;ufer kann mit befreiender Wirkung an den jeweiligen Inhaber, der
              den Geschenkgutschein im Online-Shop des Verk&auml;ufers einl&ouml;st,
              leisten. Dies gilt nicht, wenn der Verk&auml;ufer Kenntnis oder grob
              fahrl&auml;ssige Unkenntnis von der Nichtberechtigung, der
              Gesch&auml;ftsunf&auml;higkeit oder der fehlenden Vertretungsberechtigung
              des jeweiligen Inhabers hat.</p>
            <h2>13) Anwendbares Recht</h2>
            <p><b>13.1</b>&nbsp;F&uuml;r s&auml;mtliche Rechtsbeziehungen zwischen uns
              gilt das Recht der Bundesrepublik Deutschland unter Ausschluss der
              Gesetze &uuml;ber den internationalen Kauf beweglicher Waren. Wenn du als
              Verbraucher handelst, gilt diese Rechtswahl nur insoweit, als nicht der dir
              durch zwingende Bestimmungen des Rechts des Staates, in dem du deinen
              gew&ouml;hnlichen Aufenthalt hast, gew&auml;hrte Schutz entzogen wird.</p>
            <p><b>13.2</b>&nbsp;Ferner gilt diese Rechtswahl im Hinblick auf das
              gesetzliche Widerrufsrecht nicht bei Verbrauchern, die zum Zeitpunkt des
              Vertragsschlusses keinem Mitgliedstaat der Europ&auml;ischen Union
              angeh&ouml;ren und deren alleiniger Wohnsitz und Lieferadresse zum Zeitpunkt
              des Vertragsschlusses au&szlig;erhalb der Europ&auml;ischen Union liegen.
            </p>
            <h2>14) Gerichtsstand</h2>
            <p>Handelst du als Kaufmann, juristische Person des &ouml;ffentlichen Rechts
              oder &ouml;ffentlich-rechtliches Sonderverm&ouml;gen mit Sitz im
              Hoheitsgebiet der Bundesrepublik Deutschland, ist ausschlie&szlig;licher
              Gerichtsstand f&uuml;r alle Streitigkeiten aus diesem Vertrag unser
              Gesch&auml;ftssitz. Hast du deinen Sitz au&szlig;erhalb des Hoheitsgebiets
              der Bundesrepublik Deutschland, so ist unser Gesch&auml;ftssitz
              ausschlie&szlig;licher Gerichtsstand f&uuml;r alle Streitigkeiten aus diesem
              Vertrag, wenn der Vertrag oder Anspr&uuml;che aus dem Vertrag der
              beruflichen oder gewerblichen T&auml;tigkeit dir zugerechnet werden
              k&ouml;nnen. Wir sind in den vorstehenden F&auml;llen jedoch in jedem Fall
              berechtigt, das Gericht an Deinem Sitz anzurufen.</p>
            <h2>15) Alternative Streitbeilegung</h2>
            <p>Wir sind zur Teilnahme an einem Streitbeilegungsverfahren vor einer
              Verbraucherschlichtungsstelle nicht verpflichtet, hierzu aber bereit.</p>
          </div>

          <div id="widerruf">
            <h1>Widerrufsbelehrung &amp; Widerrufsformular</h1>
            <h2>A. Widerrufsbelehrung</h2>
            <h3>Einleitung</h3>
            <p>Verbrauchern steht ein Widerrufsrecht nach folgender Ma&szlig;gabe zu,
              wobei
              Verbraucher jede nat&uuml;rliche Person ist, die ein Rechtsgesch&auml;ft zu
              Zwecken abschlie&szlig;t, die &uuml;berwiegend weder ihrer gewerblichen noch
              ihrer selbst&auml;ndigen beruflichen T&auml;tigkeit zugerechnet werden
              k&ouml;nnen:</p>
            <h3>Widerrufsrecht</h3>
            <p>Sie haben das Recht, binnen vierzehn Tagen ohne Angabe von Gr&uuml;nden
              diesen Vertrag zu widerrufen.</p>
            <p>Die Widerrufsfrist betr&auml;gt vierzehn Tage ab dem Tag, an dem Sie oder
              ein
              von Ihnen benannter Dritter, der nicht der Bef&ouml;rderer ist, die letzte
              Ware in Besitz genommen haben bzw. hat.</p>
            <p>Um Ihr Widerrufsrecht auszu&uuml;ben, m&uuml;ssen Sie uns
              (Becker &amp; Karsten UG (haftungsbeschr&auml;nkt), Sandhauser Str. 107,
              13505
              Berlin, Deutschland, Tel.: +49 30 609851960, E-Mail:
              wir@beckerundkarsten.de)
              mittels einer eindeutigen Erkl&auml;rung (z. B. ein mit der Post versandter
              Brief oder E-Mail) &uuml;ber Ihren Entschluss, diesen Vertrag zu widerrufen,
              informieren. Sie k&ouml;nnen daf&uuml;r das beigef&uuml;gte
              Muster-Widerrufsformular verwenden, das jedoch nicht vorgeschrieben ist.</p>
            <p>Sie k&ouml;nnen Ihr Widerrufsrecht auch online auf der Webseite unter der
              Internetadresse <a href="https://widerruf.beckerundkarsten.de"
                                 target="_blank">https://widerruf.beckerundkarsten.de</a> aus&uuml;ben.
              Wenn Sie diese Online-Funktion nutzen, wird Ihnen auf einem dauerhaften
              Datentr&auml;ger (z. B. durch eine E-Mail) unverz&uuml;glich eine
              Eingangsbest&auml;tigung mit Informationen zum Inhalt der
              Widerrufserkl&auml;rung sowie dem Datum und der Uhrzeit ihres
              Eingangs &uuml;bermittelt.</p>
            <p>Zur Wahrung der Widerrufsfrist reicht es aus, dass Sie die
              Mitteilung &uuml;ber die Aus&uuml;bung des Widerrufsrechts vor Ablauf der
              Widerrufsfrist absenden.</p>
            <h3>Folgen des Widerrufs</h3>
            <p>Wenn Sie diesen Vertrag widerrufen, haben wir Ihnen alle Zahlungen, die wir
              von Ihnen erhalten haben, einschlie&szlig;lich der Lieferkosten (mit
              Ausnahme
              der zus&auml;tzlichen Kosten, die sich daraus ergeben, dass Sie eine andere
              Art der Lieferung als die von uns angebotene, g&uuml;nstigste
              Standardlieferung gew&auml;hlt haben), unverz&uuml;glich und sp&auml;testens
              binnen vierzehn Tagen ab dem Tag zur&uuml;ckzuzahlen, an dem die
              Mitteilung &uuml;ber Ihren Widerruf dieses Vertrags bei uns eingegangen ist.
              F&uuml;r diese R&uuml;ckzahlung verwenden wir dasselbe Zahlungsmittel, das
              Sie
              bei der urspr&uuml;nglichen Transaktion eingesetzt haben, es sei denn, mit
              Ihnen wurde ausdr&uuml;cklich etwas anderes vereinbart; in keinem Fall
              werden
              Ihnen wegen dieser R&uuml;ckzahlung Entgelte berechnet. Wir k&ouml;nnen die
              R&uuml;ckzahlung verweigern, bis wir die Waren wieder zur&uuml;ckerhalten
              haben oder bis Sie den Nachweis erbracht haben, dass Sie die Waren
              zur&uuml;ckgesandt haben, je nachdem, welches der fr&uuml;here Zeitpunkt
              ist.</p>
            <p>Sie haben die Waren unverz&uuml;glich und in jedem Fall sp&auml;testens
              binnen vierzehn Tagen ab dem Tag, an dem Sie uns &uuml;ber den Widerruf
              dieses
              Vertrags unterrichten, an uns zur&uuml;ckzusenden oder zu &uuml;bergeben.
              Die
              Frist ist gewahrt, wenn Sie die Waren vor Ablauf der Frist von vierzehn
              Tagen
              absenden.</p>
            <p>Sie tragen die unmittelbaren Kosten der R&uuml;cksendung der Waren.</p>
            <p>Sie m&uuml;ssen f&uuml;r einen etwaigen Wertverlust der Waren nur
              aufkommen,
              wenn dieser Wertverlust auf einen zur Pr&uuml;fung der Beschaffenheit,
              Eigenschaften und Funktionsweise der Waren nicht notwendigen Umgang mit
              ihnen
              zur&uuml;ckzuf&uuml;hren ist.</p>
            <h3>Ausschluss bzw. vorzeitiges Erl&ouml;schen des Widerrufsrechts</h3>
            <p>Das Widerrufsrecht besteht nicht bei Vertr&auml;gen zur Lieferung von
              Waren,
              die nicht vorgefertigt sind und f&uuml;r deren Herstellung eine individuelle
              Auswahl oder Bestimmung durch den Verbraucher ma&szlig;geblich ist oder die
              eindeutig auf die pers&ouml;nlichen Bed&uuml;rfnisse des Verbrauchers
              zugeschnitten sind.</p>
            <p>Das Widerrufsrecht gilt nicht f&uuml;r Verbraucher, die zum Zeitpunkt des
              Vertragsschlusses keinem Mitgliedstaat der Europ&auml;ischen Union
              angeh&ouml;ren und deren alleiniger Wohnsitz und Lieferadresse zum Zeitpunkt
              des Vertragsschlusses au&szlig;erhalb der Europ&auml;ischen Union
              liegen.</p>
            <h2>B. Widerrufsformular</h2>
            <p>Wenn Sie den Vertrag widerrufen wollen, dann f&uuml;llen Sie bitte dieses
              Formular aus und senden es zur&uuml;ck.</p>
            <p>An</p>
            <p>Becker &amp; Karsten UG (haftungsbeschr&auml;nkt)<br/>
              Sandhauser Str. 107<br/>
              13505 Berlin<br/>
              Deutschland</p>
            <p>E-Mail: wir@beckerundkarsten.de</p>
            <p>Hiermit widerrufe(n) ich/wir (*) den von mir/uns (*) abgeschlossenen
              Vertrag &uuml;ber den Kauf der folgenden Waren (*) / die Erbringung der
              folgenden Dienstleistung (*)</p>
            <p>_______________________________________________________</p>
            <p>_______________________________________________________</p>
            <p>Bestellt am (*) ____________ / erhalten am (*) __________________</p>
            <p>________________________________________________________<br/>
              Name des/der Verbraucher(s)</p>
            <p>________________________________________________________<br/>
              Anschrift des/der Verbraucher(s)</p>
            <p>________________________________________________________<br/>
              Unterschrift des/der Verbraucher(s) (nur bei Mitteilung auf Papier)</p>
            <p>_________________________<br/>
              Datum</p>
            <p>(*) Unzutreffendes streichen</p>
          </div>
          <div style={{ marginTop: '3rem', }}>
            <div style={{
              display: 'inline-block',
              verticalAlign: 'top',
            }}><a
              href="https://www.it-recht-kanzlei.de/" target="_blank"><img
              src="https://www.it-recht-kanzlei.de/logo/Copyright-Logo_Widerrufsbelehrung.png?i=334dc-19c5e-39c9-907f-1"
              id="itkanzlei_img_copyright" alt="&copy; IT-Recht Kanzlei"
              title="&copy; IT-Recht Kanzlei"
              style={{
                marginTop: '-20px',
                borderStyle: 'none',
                maxWidth: '100%',
              }}/></a></div>
            <div
              style={{
                display: 'inline-block',
                verticalAlign: 'top',
                marginLeft: '5px',
                float: 'right',
                whiteSpace: 'nowrap',
              }}>Stand:
              18.06.2026, 12:13:03
            </div>
            <div style={{ clear: 'right' }}></div>
          </div>
        </ContentWrapper>
      </article>
    </React.Fragment>
  );
};

export default Tos;



// WEBPACK FOOTER //
// ./src/components/de/Tos.js